const fluxItemsStates = Object.freeze({
  created: { label: 'créé', color: 'grey' },
  treated: { label: 'traité', color: '#14617E' },
  skipped: { label: 'passé', color: '#FF9800' },
  rejected: { label: 'rejeté', color: '#FF0000' },
  validated: { label: 'validé', color: '#34C2B8' },
})

export { fluxItemsStates }
